import React, { useContext } from 'react';
import styled from 'styled-components';
import useGetIncompatibleBottle from 'hooks/useGetIncompatibleBottle';
import ui from 'config-app/ui';
import { appStore } from 'store/app';
const Component = ({ variants, products, selectedId, onClick }) => {

  const [appState] = useContext(appStore);
  let colorId = null;
  if ( window.CB.isMTA ) {
     colorId = appState.steps[0].bottleColor;
  } else {
    colorId = appState.steps.find((v) => v.type === "bottleColor").id;
  }
  const bottleList = window.CB.Bottle.products[colorId];


  return (
    <Container>
      <Options>
        <div className="inner">
          {variants.map((id, index) => {
            let outOfStock = false;
            const selectedItem = bottleList.variants[id];
            const inventoryPolicy = selectedItem.inventory_policy;
            const inventoryQuantity = selectedItem.inventory_quantity;
            if (inventoryQuantity <= 0 && inventoryPolicy === "deny") {
              outOfStock = true;
            }
            return (
              <SizeItem
                key={index}
                id={id}
                image={products[id].image}
                selected={selectedId === id}
                onClick={onClick}
                outOfStock={outOfStock}
              />
            );
          })}
        </div>
      </Options>
    </Container>
  );
};

const SizeItem = ({ outOfStock, id, image, selected, onClick }) => {
  const disabled = useGetIncompatibleBottle(id, 'BottleSize');
  if (!disabled) {
    return (
      <Item
        image={image}
        selected={selected}
        onClick={() => onClick(id)}
        disabled={outOfStock && "disabled"}
      >
        <div className="label">{id}</div>
      </Item>
    );
  } else {
    return null;
  }
};

export default Component;

const Container = styled.div`
  margin-top: 20px;
  ${ui.MQ_XS_SM} {
    margin-top: 14px;
    margin-left: -30px;
  }
`;

const Options = styled.div`
  ${ui.MQ_XS_SM} {
    margin-right: -25px;
    overflow-x: auto;
    width: 100vw;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    .inner {
      &::after {
        content: '';
        flex-shrink: 0;
        width: 1px;
        height: 1px;
      }
    }
  }

  .inner {
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    align-items: center;
  }
`;

const Item = styled.div`
  cursor: pointer;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) => (props.selected ? '3px solid #333333' : '1px solid #D7D7D7')};
  font-weight: ${(props) => (props.selected ? 'bold' : '')};
  &[disabled] {
    &::after {
      content: '';
      display: block;
      position: absolute;
    }
    .label {
      color: #D7D7D7;
    }
  }
  .label {
    color: #333333;
    box-sizing: border-box;
  }

  ${ui.MQ_XS_SM} {
    width: calc((100vw - 90px)  / 3);
    height: 40px;
    flex-shrink: 0;
    margin-right: 15px;
    &:first-child {
      margin-left: 30px;
    }
    &[disabled] {
      &::after {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: .2;
       background-image: linear-gradient(to bottom right,
                        transparent, transparent 48%,
                        rgba(136, 136, 136) 48%, rgba(136, 136, 136) 53%,
                        transparent 53%, transparent);
      }
    }
  }

  ${ui.MQ_MD_LG} {
    flex-shrink: 0;
    width: 120px;
    height: 50px;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &[disabled] {
      &::after {
        width: 200px;
        background: rgba(136, 136, 136, .2);
        height: 4px;
        transform: rotate(-22deg);
      }
    }

    .label {
      font-size: 16px;
      text-align: center;
    }
  }
`;
